import { ComparisonEntry } from '@comparison/const';
import { Category } from '@spartacus/core';
import { ComparisonActions } from '../actions';
import { ComparisonState } from '../comparison-state';

export const initialState: ComparisonState = {
  entries: [],
  loading: {},
  activeCategory: undefined,
  sortedCategory: [],
};

const sortedCategoriesReducer = (state: ComparisonState, action: ComparisonActions.ComparisonActions): Category[] => {
  switch (action.type) {
    case ComparisonActions.COMPARISON_ADD_ENTRY_SUCCESS: {
      const { entry } = action.payload;
      // категория добавленного товара - либо берём существующую, либо создаём
      const entryCategoryCount = {
        ...(state.sortedCategory.find((category: Category) => category.code === entry.category.code) || entry.category),
      };

      // категорию товара ставим в начало
      return [
        entryCategoryCount,
        ...state.sortedCategory.filter((category: Category) => category.code !== entryCategoryCount.code),
      ];
    }

    case ComparisonActions.COMPARISON_REMOVE_ENTRY: {
      // товары без удалённого
      const entries = state.entries.filter((entry: ComparisonEntry) => entry.productId !== action.payload.productId);
      // осталась ли активная категория пустой
      const activeCategoryIsRemoved = !entries.some((entry) => entry.category.code === state.activeCategory);

      const categoryCounts = activeCategoryIsRemoved
        ? // если осталась - категории без активной, потом проставим активной первую
          state.sortedCategory.filter((category: Category) => category.code !== state.activeCategory)
        : // если активная категория не пустая - просто уменьшаем количество
          state.sortedCategory;

      return categoryCounts;
    }

    case ComparisonActions.COMPARISON_REMOVE_CATEGORY: {
      return state.sortedCategory.filter((category: Category) => category.code !== action.payload.code);
    }

    case ComparisonActions.COMPARISON_SET_STATE: {
      const data: { [key: string]: Category } = {};

      for (const entry of action.payload.entries) {
        if (!Object.prototype.hasOwnProperty.call(data, entry.category.code)) {
          data[entry.category.code] = entry.category;
        }
      }

      return Object.values(data);
    }

    default: {
      return state.sortedCategory;
    }
  }
};

export function reducer(state = initialState, action: ComparisonActions.ComparisonActions): ComparisonState {
  switch (action.type) {
    case ComparisonActions.COMPARISON_ADD_ENTRY: {
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.productId]: true,
        },
      };
    }

    case ComparisonActions.COMPARISON_SET_ACTIVE_CATEGORY: {
      return {
        ...state,
        activeCategory: action.payload,
      };
    }

    case ComparisonActions.COMPARISON_ADD_ENTRY_SUCCESS: {
      const { entry } = action.payload;
      const entries = [...state.entries, action.payload.entry];

      return {
        ...state,
        entries,
        loading: {
          ...state.loading,
          [action.payload.productId]: false,
        },
        activeCategory: entry.category.code,
        sortedCategory: sortedCategoriesReducer(state, action),
      };
    }

    case ComparisonActions.COMPARISON_ADD_ENTRY_ERROR:
    case ComparisonActions.COMPARISON_CATEGORIES_LIMIT_EXCEEDED:
    case ComparisonActions.COMPARISON_PRODUCTS_LIMIT_EXCEEDED: {
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.productId]: false,
        },
      };
    }

    case ComparisonActions.COMPARISON_REMOVE_ENTRY: {
      // товары без удалённого
      const entries = state.entries.filter((entry: ComparisonEntry) => entry.productId !== action.payload.productId);
      // осталась ли активная категория пустой
      const activeCategoryIsRemoved = !entries.some((entry) => entry.category.code === state.activeCategory);
      const sortedCategories = sortedCategoriesReducer(state, action);

      const loading = { ...state.loading };
      delete loading[action.payload.productId];

      return {
        loading,
        entries,
        sortedCategory: sortedCategories,
        activeCategory: activeCategoryIsRemoved ? sortedCategories[0]?.code : state.activeCategory,
      };
    }

    case ComparisonActions.COMPARISON_REMOVE_CATEGORY: {
      const entries = state.entries.filter((entry: ComparisonEntry) => entry.category.code !== action.payload.code);
      const sortedCategories = sortedCategoriesReducer(state, action);

      const loading = { ...state.loading };

      for (const entry of state.entries) {
        if (!entries.includes(entry)) {
          delete loading[entry.productId];
        }
      }

      return {
        loading,
        entries,
        sortedCategory: sortedCategories,
        activeCategory: action.payload.code !== state.activeCategory ? state.activeCategory : sortedCategories[0]?.code,
      };
    }

    case ComparisonActions.COMPARISON_RESET: {
      return initialState;
    }

    case ComparisonActions.COMPARISON_SET_STATE: {
      return {
        ...action.payload,
        sortedCategory: sortedCategoriesReducer(state, action),
      };
    }

    default: {
      return state;
    }
  }
}
